export default __webpack_public_path__ + "static/media/pocketcasts_podcast.48e624cb.svg";